import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/maintenance')({
	component: SessionExpired,
})

function SessionExpired() {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.ctrlKey && event.key === 'b') {
				localStorage.setItem('bypass-maintenance', Date.now().toString())
				window.location.href = '/'
			}
		}

		window.addEventListener('keydown', handleKeyDown)

		return () => {
			window.removeEventListener('keydown', handleKeyDown)
		}
	}, [])

	return (
		<div className="bg-navy-100 flex h-full flex-col items-center justify-center p-[24px]">
			<div className="flex flex-wrap items-center justify-center gap-[20px]">
				<img
					alt="University of Melbourne"
					src="/logos/uom_logo.svg"
					className="h-[90px]"
				/>
				<img
					alt="Aila"
					src="/logos/aila_logo.svg"
					className="mt-[3px] h-[60px]"
				/>
			</div>
			<div className="font-lead pt-[24px] text-center text-[70px] text-white">Down for Maintenance</div>
			<div className="text-light-grey-25 max-w-[1080px] pt-[40px] text-center text-[38px] leading-[48px] font-[300]">
				Aila is down for maintenance, we expect to have it back up by {import.meta.env.VITE_DOWN_FOR_MAINTENANCE_UNTIL}.
			</div>
		</div>
	)
}
